var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAutoFixHigh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.751 6.25L17.5344 4.53333L19.251 3.75L17.5344 2.96667L16.751 1.25L15.9677 2.96667L14.251 3.75L15.9677 4.53333L16.751 6.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16771 6.25L7.95105 4.53333L9.66771 3.75L7.95105 2.96667L7.16771 1.25L6.38438 2.96667L4.66771 3.75L6.38438 4.53333L7.16771 6.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.751 10.8333L15.9677 12.55L14.251 13.3333L15.9677 14.1167L16.751 15.8333L17.5344 14.1167L19.251 13.3333L17.5344 12.55L16.751 10.8333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8427 8.01667L12.4844 5.65833C12.3177 5.5 12.1094 5.41667 11.8927 5.41667C11.676 5.41667 11.4677 5.5 11.301 5.65833L1.99271 14.9667C1.66771 15.2917 1.66771 15.8167 1.99271 16.1417L4.35105 18.5C4.51771 18.6667 4.72605 18.75 4.94271 18.75C5.15938 18.75 5.36771 18.6667 5.53438 18.5083L14.8427 9.2C15.1677 8.875 15.1677 8.34167 14.8427 8.01667ZM11.8927 7.43333L13.0677 8.60833L12.0927 9.58333L10.9177 8.40833L11.8927 7.43333ZM4.94271 16.7417L3.76771 15.5667L9.74271 9.58333L10.9177 10.7583L4.94271 16.7417Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAutoFixHigh);
export default __webpack_public_path__ + "static/media/icon_auto_fix_high.0570faf74d6ea8babca0d5155ca2bc40.svg";
export { ForwardRef as ReactComponent };